import React, { useEffect } from 'react';
import { FormValue } from '.';
import { Field } from 'formik';
import { consentCheck } from '../../../../../utils/validators';
import { FormikInputs } from '../../../../v2BaseComponents/Inputs';

export type ConsentFieldOwnProps = {
    onChange: (value: boolean) => void;
    formValues: FormValue;
    title: string;
    isDisabled: boolean;
};

export type ConsentFieldProps = ConsentFieldOwnProps;

const ConsentField: React.FC<ConsentFieldProps> = ({ onChange, formValues, title, isDisabled }) => {
    const hasAlreadyUnset = React.useRef(false);
    const initialRender = React.useRef(true);
    useEffect(() => {
        if (hasAlreadyUnset.current) return;

        if (initialRender.current) {
            initialRender.current = false;
            return;
        }

        hasAlreadyUnset.current = true;
        onChange(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formValues.appPermissions]);

    return (
        <Field
            name="acceptConsent"
            isDisabled={isDisabled}
            validate={consentCheck}
            component={FormikInputs.Checkbox}
            title={title}
            topAlignCheckbox
        />
    );
};

export default React.memo(ConsentField);
